import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { ModalHeading } from 'components/Modal/ModalStyles';
import Modal from 'components/Modal/Modal';
import ModalContainer from 'components/Modal/ModalContainer';
import { Box } from 'components/StyledSystem/Box';
import PrimaryButton from 'components/Button/PrimaryButton';
import Text from 'components/StyledSystem/Text';

const ResetPinConfirmationModal = (props) => {
  const {
    onClose,
  } = props;

  const {
    email,
  } = useSelector(({ user }) => ({
    email: user.contactEmail,
  }));

  return (
    <Modal
      onDismiss={onClose}
      aria-labelledby="reset-pin-confirm-header"
      aria-describedby="reset-pin-confirm-desc"
    >
      <ModalContainer
        onClickClose={onClose}
        withWidth="medium"
        withShadow
        dark
      >
        <Box column>
          <Box mt="medium" mb="large">
            <ModalHeading id="appSettings.sendNewPinCodeModalHeader" domId="reset-pin-confirm-header" />
          </Box>

          <Box textAlign="center">
            <Text
              bold
              align="center"
              id="appSettings.sendNewPinCodeModalSuccessModalInfo"
              domId="reset-pin-confirm-desc"
              values={{ email }}
            />
          </Box>

          <Box
            mt="xxxlarge"
            mb="xlarge"
          >
            <PrimaryButton
              variant="brand"
              onClick={onClose}
            >
              <Text id="appSettings.sendNewPinCodeModalBtnText" />
            </PrimaryButton>
          </Box>
        </Box>
      </ModalContainer>
    </Modal>
  );
};

ResetPinConfirmationModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default ResetPinConfirmationModal;
